import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowRightIcon } from 'lucide-react';
import { FOUNDER } from '../../data/dgpt';
import { SectionHeading } from '../ui/SectionHeading';
import { Reveal } from '../ui/Reveal';
import { FounderAvatar } from '../FounderAvatar';
export function FounderSection() {
  return <section aria-labelledby="founder-heading" className="border-b border-hairline-soft bg-surface" data-id="element-132" data-mp="2cg2ntg4xuixg">
      <div className="mx-auto grid w-full max-w-[1320px] gap-10 px-4 py-20 sm:px-6 lg:grid-cols-2 lg:items-center lg:gap-16 lg:px-8 lg:py-24" data-id="element-133" data-mp="1oqhzehq0mtgs">
        <SectionHeading eyebrow="Team" headingId="founder-heading" title="Built by people who understand venture." data-id="element-134" data-mp="1joizjhthieol" />
        <Reveal delay={0.06} className="flex flex-col gap-5 rounded-2xl border border-hairline bg-panel p-6 sm:flex-row sm:p-7" data-id="element-135" data-mp="1totdj4ncfq4t">
          <FounderAvatar data-id="element-136" data-mp="15xxd5j4tnmly" />
          <div data-id="element-137" data-mp="15x4ez6jxi5ff">
            <h3 className="text-lg font-semibold text-text-primary" data-id="element-138" data-mp="15wuprl6pk2as">{FOUNDER.name}</h3>
            <p className="text-sm text-text-secondary" data-id="element-139" data-mp="10zm4vcu6dk5u">{FOUNDER.role}</p>
            <p className="mt-3 text-[15px] leading-relaxed text-text-secondary" data-id="element-140" data-mp="2cl4b5dpu1ixq">{FOUNDER.bio}</p>
            <Link to="/about" className="mt-4 inline-flex min-h-[44px] items-center gap-1.5 text-sm font-semibold text-lime hover:underline focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-lime" data-id="element-141" data-mp="2gmfux2m0z9y0">
              About StartupFuel
              <ArrowRightIcon className="h-4 w-4" aria-hidden="true" data-id="element-142" data-mp="1tnt9xnkn4ffn" />
            </Link>
          </div>
        </Reveal>
      </div>
    </section>;
}